// extracted by mini-css-extract-plugin
module.exports = {"counterCard":"CounterCard_counterCard__3UBJN","titlehead":"CounterCard_titlehead__hNJGG","counthead":"CounterCard_counthead__1OM74"};